import React from 'react';
import { injectIntl, FormattedMessage } from "gatsby-plugin-react-intl"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class SDKWarning extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      showWarning: false
    };
  }

  componentDidMount() {

    if (/sdk/.test(document.location.pathname)) {
      if (![/v4/, /v5/].some(r => r.test(document.location.pathname))) {
        this.setState({
          showWarning: true
        });
      }
    }

  }

  render() {
    if (this.state.showWarning) {
      return (
        <div className={`sdk-warning`}>
          <div className={`icon`}>
            <FontAwesomeIcon icon="exclamation-triangle" size={`2x`} />
          </div>
          <div className={`text`}>
            <FormattedMessage id="shared.sdkWarning" />
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default injectIntl(SDKWarning)
